//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vComponent from '@/core/vComponent'
import { mapGetters } from 'vuex'
import { userInfo, searchVipBar, funSticky } from './components'
import { poshTransRecord, transTransRecord, rchgTrans, ptTrans } from './transaction'
// import { transRecord } from './transaction_trans'
export default {
  name: 'TransactionPage',
  extends: vComponent,
  // components: { userInfo, searchVipBar },
  components: { poshTransRecord, transTransRecord, rchgTrans, ptTrans, userInfo, searchVipBar, funSticky },
  data () {
    return {
      defaultTab: 'transRecord', // 預設起始tab
      selectedTab: '',
      tabs: [
        { id: 'transRecord', label: '會員交易紀錄' },
        { id: 'rchgTrans', label: '會員儲值紀錄' },
        { id: 'ptTrans', label: '會員點數紀錄' }
      ],
      info: null
    }
  },
  computed: {
    ...mapGetters([
      'builderHost',
      'dateFormat',
      'site',
      'theme',
      'siteConfig'
    ]),
    selectedTabLabel () {
      let label = ''
      this.tabs.forEach(tab => {
        if (tab.id === this.selectedTab) label = tab.label
      })
      return label
    }
  },
  created () {
    this.selectedTab = this.defaultTab
  },
  mounted () {
    this.info = this.$refs.userInfo.currentVip
  },
  watch: {
    selectedTab (val, oldVal) {
      switch (val) {
        case 'transRecord':
          // this.emit('TransRecord.Query')
          break
        case 'rchgTrans':
          // this.emit('RchgTrans.Query')
          break
        case 'ptTrans':
          // this.emit('PtTrans.Query')
          break
      }
    }
  },
  methods: {
  }
}
